import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Form, FormFieldValidationResult, IFormData} from "@mintdata-wsp/common/components/form/Form";
import {Button, ButtonStyle} from '@mintdata-wsp/common/components/button/Button';
import {Input, InputStyle} from "@mintdata-wsp/common/components/input/Input";
import {ErrorPopupSide, IFormFieldState} from "@mintdata-wsp/common/components/formField/FormField";
import bind from "bind-decorator";
import {Validators} from "@mintdata-wsp/common/components/validators/Validators";

const styles = require('./InvitorInput.less');
const cx = classnames.bind(styles);

export interface InvitorInputProps
{
    className?:string;
    onEnteredEmail?:(email:string)=>(void);
    validateFn?:(email:string)=>(Promise<FormFieldValidationResult>);
}

@observer
export class InvitorInput extends React.Component<InvitorInputProps, any>
{
    @observable
    externalValidationInProgress:boolean = false;

    private _form:Form = new Form({
        onSubmit: this._onFormSubmit
    });

    constructor(props:any)
    {
        super(props);
    }

    @bind
    private _onFormSubmit(formData:IFormData)
    {
        this._checkEmail();
    }

    @bind
    private _onAddButton(e:any):void
    {
        this._checkEmail();
    }

    @action.bound
    private _checkEmail()
    {
        if (this.externalValidationInProgress) return;

        const isValidInputValue = this._form.areAllFieldsValid() && !this._form.areSomeFieldIsEmpty();

        if (!isValidInputValue) return;

        const {validateFn} = this.props;

        if (validateFn && typeof validateFn == 'function')
        {
            this.externalValidationInProgress = true;

            validateFn(this._form.get('email'))
            .then(action((validationResult:FormFieldValidationResult) =>
            {
                if (validationResult.isValid)
                    this._onEnteredEmail();
                else
                {
                    this._form.setServerError('email', validationResult.errorMessage);
                }
                this.externalValidationInProgress = false;
            }))
            .catch(err =>
            {
                console.warn(err);
                this.externalValidationInProgress = true;
            })
        }
        else
        {
            this._onEnteredEmail();
        }
    }

    @bind
    private _onEnteredEmail()
    {
        const {onEnteredEmail} = this.props;

        if (onEnteredEmail && typeof onEnteredEmail == 'function')
            onEnteredEmail(this._form.get('email'));

        const emailField = this._form.getField('email');

        emailField.reset();
    }

    private _validateEmail(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
            [
                Validators.emptyNotDirtyIsValid(),
                Validators.serverError('email'),
                Validators.email('Please enter valid email address'),
            ]);
    }

    render()
    {
        const {className} = this.props;

        return  (
            <Row className={cx('invitorInputRow', className)}>
                <Input className={cx('input')}
                       style={InputStyle.Simple}
                       icon={MDIcons.common.Email}
                       initialValue={''}
                       isInitiallyFocused={true}
                       placeholder={`Enter an email address to invite new member`}
                       form={this._form}
                       formKey={'email'}
                       validationFn={this._validateEmail}
                       errorPopupSide={ErrorPopupSide.Bottom}
                       />

                <Button
                    caption={'Add'}
                    onClick={this._onAddButton}
                    style={ButtonStyle.Simple}
                    />
            </Row>
        );
    }
}
